<template>
<div id="app">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
            <div class="ibox-title">
                <el-form id="elForm" :model="formInline" ref="formInline" label-position="right" :inline="true"  class="demo-form-inline" label-width="96px" size="medium">
                    <el-form-item label="市：" prop="cityID" v-show="show.selCity">
                        <el-select v-model="formInline.cityID" placeholder="请选择市" @change="selectChange(1,formInline.cityID)">
                            <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区县：" prop="countryID" v-show="show.selCountry">
                        <el-select v-model="formInline.countryID" placeholder="请选择区" @change="selectChange(2,formInline.countryID)">
                            <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="幼儿园：" prop="kindOrgID">
                        <el-select v-model="formInline.kindOrgID" placeholder="请选择幼儿园" filterable>
                            <el-option v-for="item in selectGarden" :key="item.orgKindID" :label="item.fullName" :value="item.orgKindID"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="性别：">
                        <el-select v-model="formInline.sex" placeholder="请选择性别">
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option key="男" label="男" value="男"></el-option>
                            <el-option key="女" label="女" value="女"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="身份证号码：">
                        <el-input v-model="formInline.idCard"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名：">
                        <el-input v-model="formInline.childName"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人：">
                        <el-input v-model="formInline.relation"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码：">
                        <el-input v-model="formInline.relationPhone"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="btn-primary" @click="query()">查询</el-button>
                    </el-form-item>
                </el-form>
                <div class="mb15">
                  <!-- <el-button @click="AddTo()"><i class="el-icon-edit"></i>&nbsp;添加</el-button>
                  <el-button @click="removegGarten()"><i class="el-icon-delete"></i>&nbsp;删除</el-button> -->
                  <el-button v-for='(item,index) in generalArea' :key='index' class="btn-outline" @click="doClick(item.operFunc)"  plain>{{item.operName}}</el-button>
                </div>
                <!-- 用户列表-->
                <el-table :data="tableData" style="width: 100%" class="table-bordered" v-loading="tableLoading" element-loading-text="拼命加载中">
                    <el-table-column type="selection" current-row-key="childID" width="55"></el-table-column>
                    <el-table-column prop="childName" label="姓名"></el-table-column>
                    <el-table-column prop="sex" label="性别"></el-table-column>
                    <el-table-column prop="birthday" label="生日"  show-overflow-tooltip></el-table-column>
                    <el-table-column prop="fullName" label="所属幼儿园" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="idCard" label="身份证号码" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="relation" label="联系人"></el-table-column>
                    <el-table-column prop="relationPhone" label="手机号码" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="street" label="地址" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <!-- <el-button class="btn-warning btn-outline" @click="go(scope.$index,scope.row)" size="small" plain><i class="el-icon-document"></i>详情</el-button> -->
                            <el-button v-for='(item,index) in listArea' :key='index' class="btn-outline" @click="doClick(item.operFunc,scope.$index,scope.row)" size="small" plain>{{item.operName}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination :current-page="formInline.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total_rows"
                    @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top: 10px;">
                </el-pagination>
            </div>
        </div>
      </div>
    </div>
    <!--彈出的添加-->
    <el-dialog  :visible.sync="dialogTableVisible" :close-on-click-modal='false'>
        <router-view v-on:close="close"></router-view>
    </el-dialog>
</div>
</template>
<script>

import { MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import common from '../../com/common'

export default {
  name: 'app',
  data () {
    return {
            // 对象属性
      formInline: {
        kindOrgID: '',
        provinceID: '',
        sex: '',
        idCard: '',
        childName: '',
        relation: '',
        relationPhone: '',
        pageNum: 1,
        pageSize: 10
      },
      tableData: [], // 加载出来的表格数据
      total_rows: 0,
      tableLoading: false,
      dialogTableVisible: false,
      show: {
        selCountry: false,
        selCity: false
      },
      selectpro: [], // 筛选条件下拉框省数据
      selectcity: [], // 筛选条件下拉框市数据
      selectarea: [], // 筛选条件下拉框区数据
      selectGarden: [{orgKindID: '', fullName: '全部'}], // 筛选条件下拉框幼儿园数据

      idCard: '',
      childName: '',
      sex: '',
      birthday: '',
      fullName: '',
      relation: '',
      relationPhone: '',
      street: '',
      generalArea:[],
      listArea:[]
    }
  },
  methods: {
    selectChange (type, parentID) { // 下拉框值改变事件  type=1市下拉框的值改变事件   type=2区下拉框的值改变事件
      if (type === 1) {
        this.selectarea = [{id: '', name: '全部'}]
        if (parentID !== '') {
          this.getList('common/getAreasList.do', { 'parentID': parentID }, 'selectarea')
        }
        this.formInline.countryID = ''
        this.selectGarden = [{orgKindID: '', fullName: '全部'}]
        this.formInline.kindOrgID = ''
        this.getList('orgkind/getOrgKindListByArea.do', {provinceID: this.formInline.provinceID, cityID: this.formInline.cityID, countryID: ''}, 'selectGarden', true)
      } else if (type === 2) {
        this.selectGarden = [{orgKindID: '', fullName: '全部'}]
        this.formInline.kindOrgID = ''
        this.getList('orgkind/getOrgKindListByArea.do', {provinceID: this.formInline.provinceID, cityID: this.formInline.cityID, countryID: parentID}, 'selectGarden', true)
      }
    },
    getList (url, param, key, isOrg) {
      var that = this
      that[key + ''] = []
      api.post(url, param).then(function (response) {
        that[key + ''] = response.body.list
        if (isOrg) {
          that[key + ''].splice(0, 0, {orgKindID: '', fullName: '全部'})
        } else {
          that[key + ''].splice(0, 0, {id: '', name: '全部'})
        }
      })
    },
    close (flag) {
      this.dialogTableVisible = flag
    },
    pageSizeChange (val) { // 每页显示条数
      this.formInline.pageSize = val

      this.formInline.keyWord = this.keyWord

      this.getOrgs(this.formInline)
    },
    pageCurrentChange (val) { // 分页
      this.formInline.pageNum = val

      this.formInline.keyWord = this.keyWord

      this.getOrgs(this.formInline)
    },
    query (param) { // 查询按钮
      this.formInline.pageNum = 1
      this.getOrgs(this.formInline)
    },

    getOrgs (param) { // 获取页面列表
      let self = this
      api.post(config.host + 'child/kind/getChildList.do', param).then((data) => {
        if (data.success === true) {
          self.formInline.keyWord = this.keyWord

          self.tableData = data.body.list

          self.total_rows = data.body.page.total
        }
      })
    },
    go (index, row) { // 详情
      this.dialogTableVisible = true

      this.$router.push({path: '/orgmgr/detail/' + row.childID, query: { list: row }})
    },
    doClick(operFunc,index,row){
      switch(operFunc){
       case 'showDetail':this.go(index,row);break
      }
    }
  },
  created: function () {
    let self = this
        // 创建完毕状态
    api.post(config.host + 'child/kind/getChildList.do', { 'pageNum': 1, 'pageSize': 10 }).then((data) => {
      if (data.success === true) {
        self.formInline.keyWord = this.keyWord

        self.tableData = data.body.list

        self.total_rows = data.body.page.total
        self.idCard = self.tableData.idCard
        self.childName = self.tableData.childName
        self.sex = self.tableData.sex
        self.birthday = self.tableData.birthday
        self.fullName = self.tableData.fullName
        self.relation = self.tableData.relation
        self.relationPhone = self.tableData.relationPhone
        self.street = self.tableData.street
      }
    })
    api.get(config.host + 'org/getOrgDetail.do').then(function (json) {
      if (json.success === true) {
        self.formInline.provinceID = json.body.provinceID
        if (json.body.scopeType === 1) { // 当前账号是省级妇保院
          self.show.selCity = true
          self.show.selCountry = true
          self.selectcity = [{id: '', name: '全部'}]
          self.selectarea = [{id: '', name: '全部'}]
          self.getList('common/getAreasList.do', { 'parentID': json.body.provinceID }, 'selectcity')
          // that.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
          self.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID}, 'selectGarden', true)
        } else if (json.body.scopeType === 2) { // 当前账号是市级妇保院
          self.show.selCountry = true
          self.selectarea = [{id: '', name: '全部'}]
          self.getList('common/getAreasList.do', { 'parentID': json.body.cityID }, 'selectarea')
          self.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID, cityID: json.body.cityID}, 'selectGarden', true)
        } else if (json.body.scopeType === 3) { // 当前账号是区级妇保院/街道级妇保
          self.getList('orgkind/getOrgKindListByArea.do', {provinceID: json.body.provinceID, cityID: json.body.cityID, countryID: json.body.countryID}, 'selectGarden', true)
        } else if (json.body.scopeType === 4) {
          self.getList('orgkind/getOrgKindListByArea.do', {}, 'selectGarden', true)
        }
      }
    })
  },
  mounted(){
    let btnList = window.paramFromParent
    btnList = common.getBtnList(btnList)
    this.generalArea = btnList.generalArea
    this.listArea = btnList.listArea
  }
}
</script>

<style>
.main_mess ul{
    overflow:hidden;
    margin-bottom:20px;
}
.nav_cha {
    padding-left: 10px;
    border-left: 5px solid #63a0f0;
    height: 16px;
    line-height: 16px;
    margin: 12px;
    font-weight: bold;
    text-align: left;
}
.mess_li {
    float: left;
    width: 100%;
    margin-left: 30px;
    margin-top: 15px;
    list-style: none;
    text-align: left;
}
.filediv{
    display:inline-block;
}
.fileimg{
   display:block;
   width:200px;
   height:200px;
   margin-left: 76px;
}
.back{
    margin-left: 28px;
    margin-bottom: 20px;
}
.main_mess{
    border-top: 1px solid #ddd;
    padding-top: 14px;
}
.el-table th{
    background:#F5F5F5 !important;
    font-size:15px;
}
.ibox-content{
    padding: 0 20px 20px 20px;
    border:none;
}
</style>



// WEBPACK FOOTER //
// src/components/childmgr/orgsmgr.vue